import {
  FacebookOutlined,
  PhoneRounded,
  YouTube,
} from "@mui/icons-material";

import { Box, IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";


function ContactUs() {
  return (
    <div className="contact_us_bar">

      <div className="contact_us_container">

        {/* ================= SOCIAL ================= */}

        <div className="social_section">

          <span className="contact_label">
            تابعنا على
          </span>

          <div className="social_icons">

            <IconButton
              component="a"
              href="https://www.facebook.com/share/1CmykHfjCA/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="social_btn facebook"
            >
              <FacebookOutlined />
            </IconButton>


            <IconButton
              component="a"
              href="https://www.youtube.com/@Mr.Ahmedsaid667"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="social_btn youtube"
            >
              <YouTube />
            </IconButton>

          </div>

        </div>


        {/* ================= CONTACT ================= */}

        <div className="contact_numbers">

          {/* WhatsApp */}

          <a
            href="https://api.whatsapp.com/send/?phone=%2B201270567657&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="contact_item whatsapp"
          >
            <div className="contact_icon">
              <WhatsAppIcon />
            </div>

            <div className="contact_text">
              <span>واتساب</span>
              <strong>01270567657</strong>
            </div>
          </a>


          <span className="contact_divider"></span>


          {/* Phone */}

          <a
            href="tel:01207158439"
            className="contact_item phone"
          >
            <div className="contact_icon">
              <PhoneRounded />
            </div>

            <div className="contact_text">
              <span>اتصل بنا</span>
              <strong>01207158439</strong>
            </div>
          </a>

        </div>

      </div>

    </div>
  );
}

export default ContactUs;
